// src/store/crmPersist.js
// Extends existing createPersistedState reducer: persist ONLY crm UI prefs (REQ-02b).
export function crmPersistReducer(state) {
  // FT-076: tasks — server-данные (items/users), персистить нельзя (иначе устаревший
  // список исполнителей переживает перезагрузку). Всегда грузим с сервера заново.
  // network — live-состояние сети, после перезагрузки определяется заново.
  const { websocketSubscriptions, maintenanceMode, crm, notifications, tasks, network, incomingCalls, ...rest } = state;
  const persisted = { ...rest };
  if (crm) {
    persisted.crm = {
      viewMode: crm.viewMode,
      currentPipelineId: crm.currentPipelineId,
      filters: crm.filters,
      ...(crm.conversions ? { conversions: crm.conversions } : {}),
      // FT-156 REQ-07: память свёрнутых колонок по воронке — та же durability, что у фильтров.
      ...(crm.collapsedStages ? { collapsedStages: crm.collapsedStages } : {}),
    };
  }
  return persisted;
}
